export default {
  strengths: [
    'Creativity',
    'Organizational Skills',
    'Communication',
    'Taking Initiative',
    'Focus',
    'Versatility',
    'Details-oriented',
    'Integrity',
    'Flexibility',
    'Dedication',
    'Resilience',
    'Supportive',
    'Continuously Learning',
    'Leadership',
  ],
  improvements: [
    'Creativity',
    'Organizational Skills',
    'Communication',
    'Taking Initiative',
    'Focus',
    'Versatility',
    'Details-oriented',
    'Integrity',
    'Flexibility',
    'Dedication',
    'Resilience',
    'Supportive',
    'Continuously Learning',
    'Leadership',
  ],
};
